/**
 * Petite icône cadenas affichée à côté d'un bouton "Modifier" dans une liste
 * quand la ressource est actuellement verrouillée par un autre utilisateur.
 *
 * Usage :
 *   <LockIndicator lock={locks[id]} />
 */
import { Lock } from 'lucide-react';

export function LockIndicator({ lock, size = 14 }) {
    if (!lock) return null;
    const title = `${lock.user_name || 'Un autre utilisateur'} est en train de modifier cette fiche`;
    return (
        <span
            className="inline-flex items-center justify-center text-red-600"
            title={title}
            aria-label={title}
            data-testid="lock-indicator"
        >
            <Lock size={size} />
        </span>
    );
}
